/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';

import Editor from '../fw/Editor.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'organisation2UserEdit.title', 'defaultMessage': 'Editing user\'s role'}
});

interface Organisation2UserEditProps {
    intl: IntlShape;
    user: User;
}

class Organisation2UserEdit extends React.Component<Organisation2UserEditProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'organisation2user';
    static contextTypes = {
        router: PropTypes.object
    };

    constructor() {
        super();
    }

    render() {
        let data = this.props.user.organisation.organisations2user;
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type, data},
                {type: types['organisations'], data: this.props.user.organisation},
            ]} title={this.props.intl.formatMessage(messages.title)}>
                <Editor
                        columns={['role']}
                        data={data}
                        fatQuery={Relay.QL `fragment on UpdateOrganisation2UserPayload {
                            updatedNode {
                                id,
                                role,
                                organisation_id,
                            }
                        }`}
                        metadata={type}
                        mutation={Relay.QL `mutation { updateOrganisation2User }`}
                        onSuccess={() => {
                            let path = urlMapping.getUrl(types['organisation2user'], 'list', this.props.user.organisation);
                            this.context.router.push(path);
                        }}
                        organisationId={data.organisation_id}
                        urlMapping={urlMapping}
                >
                </Editor>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(Organisation2UserEdit), (props) => {
    return props.user.organisation && props.user.organisation.organisations2user;
}), {
    initialVariables: {
        organisationId: '',
        organisations2userId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    name,
                    realId,
                    organisations2user: organisations2userDetail(id: $organisations2userId) {
                        id,
                        realId,
                        organisation_id,
                        role
                    }
                }
            }
        `,
    },
});
